<div class="menu" *ngIf="showMenu">
  <ul>
    <li
      *ngFor="let menuItem of menuItems"
      (click)="menuItem.command()"
      [ngClass]="{
        disabled:
          (menuItem.label === 'GROUP' && objectKeys(currentCheckedTickets).length < 2) ||
          (menuItem.label === 'UNGROUP' && currentGroup?.length < 2),
      }"
      title="{{ menuItem.label }}"
    >
      {{ menuItem.title | xTranslate }}
      <mat-icon class="arrow" *ngIf="menuItem.label === 'CHANGE STATUS'">keyboard_arrow_right </mat-icon>
    </li>
  </ul>
</div>
<div class="status-Menu" *ngIf="showStatus">
  <ul>
    <li *ngFor="let status of ticketStatuses" (click)="changeStatus(status.key)">
      {{ status.value | uppercase }} <mat-icon *ngIf="isExistingStatus(status)">done</mat-icon>
    </li>
  </ul>
</div>
